//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "PartnerFaqBlock",

  data: function () {
    return {
      opened: [],
    }
  },
  computed: {
    isArabicLanguage: function () {
      return this.$i18n.locale === 'ar';
    }
  },
  methods: {
    clickCard: function (index) {
      let opened = [...this.opened];
      if (opened.indexOf(index) > -1) {
        opened.splice(opened.indexOf(index), 1)
      } else {
        opened.push(index)
      }
      this.opened = opened;
    }
  }
})
